import React, {/*useState, useEffect*/} from 'react';

//import InputLabel from "@material-ui/core/InputLabel";
//import Select from "@material-ui/core/Select";
//import MenuItem from "@material-ui/core/MenuItem";
//import FormControl from '@material-ui/core/FormControl';

import {VictoryChart, VictoryLine, VictoryTheme, VictoryAxis, VictoryScatter} from 'victory';
//import Paper from '@material-ui/core/Paper';

export default function SleepLogGraph (props) {
    const {data, labelSuffix} = props;


    return  <VictoryChart theme={VictoryTheme.material} animate={{ duration: 500}}>
        <VictoryAxis style={{ticks: {stroke: '#9c27b0', size: 5}, tickLabels: {fill: "white", fontSize: 8}}}/> 
        <VictoryAxis dependentAxis tickFormat={(x)=>(`${x}${labelSuffix}`)} style={{ticks: {stroke: '#9c27b0', size: 5}, tickLabels: {fill: "white", fontSize: 8}}}/> 
        <VictoryLine data={data} style={{data: { stroke: "#9c27b0", strokeWidth: 5 }, parent: { border: "1px solid #ccc"}, labels: {fontSize: 8, fill: '#ea80fc'}}} />
        <VictoryScatter data={data} style={{ data: { fill: "white" },labels: {fontSize: 15, fill: '#ea80fc'}}} events={[
      {
        target: "data",
        eventHandlers: {
          onClick: () => {
            return [{
              target: "labels",
              mutation: (props) => {
                return props.text === ""  ?
                  { text: ({datum})=>`${datum.y}` } : null
              }
            }];
          }
        }
      }
    ]}/>
    </VictoryChart>;
}

//labels={({datum})=>`${datum.y}${labelSuffix}`} 
//width={400} height={400} 
